<template>
  <div class="inputField" :class="{inputInvalid: checkValidity && !isValid}">
    <label class="textBold" :for="fieldId">
      {{ $t("bnpl:special_field.customer.last_name.label") }}
      <span v-if="required" class="bold" style="color: var(--systemError)">*</span>
    </label>
    <input
      v-model="lastName"
      :id="fieldId"
      class="textInput"
      type="text"
      autocomplete="family-name"
      @blur="blur"
    />
  </div>
</template>

<script setup>
import { useProfileStore } from "~~/stores/profile";

const props = defineProps({
  fieldId: {
    type: String,
    required: true,
  },
  required: {
    type: Boolean,
    required: true,
  },
  checkValidity: {
    type: Boolean,
    required: true,
  },
});

const lastName = ref("");

const profileStore = useProfileStore();

const isValid = computed(() => {
  if (!props.required) return true;
  if (lastName.value) return true;
  return false;
});

onBeforeMount(() => {
  lastName.value = profileStore.lastName;
});

const blur = () => {
  profileStore.customerUpdate({ lastName: lastName.value });
};
</script>

<style scoped lang="scss"></style>
